import React from 'react';

import { H1, Table } from '@betterment/samba-react';

import { BulkFeeIntentsColumns } from '../data';

export const BulkFeeIntentHeaderCell: React.FC<{
  column: BulkFeeIntentsColumns;
}> = ({ column }) => {
  return (
    <Table.ColumnHeaderCell
      css={{
        py: 'space.150',
        px: '0',
        borderRadius: 'none',
        borderTopStyle: 'solid',
        borderTopColor: 'border.weak',
        borderTopWidth: 'thin',
        verticalAlign: 'middle',
        fontSize: 'fontSize.100',
        lineHeight: 'lineHeight.100',
        ...column.css,
      }}
    >
      <H1
        color="text"
        variant="title100"
        css={{
          whiteSpace: column.css?.whiteSpace,
        }}
      >
        {column.name}
      </H1>
    </Table.ColumnHeaderCell>
  );
};
